// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__ZzcUg","downloadLabel":"style_downloadLabel__xSXsa","downloadIcon":"style_downloadIcon__BuGao","captionText":"style_captionText__kPeGJ"};